import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Http,RequestOptions} from '@angular/http';
import { AuthHttp, AuthConfig, JwtHelper } from 'angular2-jwt';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(
    new AuthConfig({
      tokenName: 'token',
      tokenGetter: (() => localStorage.getItem('id_token')),
      globalHeaders: [{'Content-Type':'application/json'}],
    }), http, options);
}

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    JwtHelper
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts